export const useFormattingSeconds = (
  seconds: number
): { hrs: number; mins: number; secs: number; formatted: string } => {
  const totalSecs = Math.round(Math.max(0, seconds));
  let hrs = Math.floor(totalSecs / 3600);
  let mins = Math.floor((totalSecs % 3600) / 60);
  let secs = totalSecs % 60;

  if (secs === 60) {
    secs = 0;
    mins += 1;
  }

  if (mins === 60) {
    mins = 0;
    hrs += 1;
  }

  return {
    hrs,
    mins,
    secs,
    formatted: `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`,
  };
};
